'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getPipoOperations = getPipoOperations;
exports.morePipoOperations = morePipoOperations;

var _constants = require('redux/constants');

/**
 * Created by maximus on 07.02.17.
 */

function getPipoOperations(begDate, endDate) {
    var id_account = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -1;
    var page = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
    var pageSize = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : _constants.OperationsNumericConstants.OPERATIONS_PAGE_LIMIT;

    return {
        types: [_constants.OperationsConstants.OPERATION_LOAD, _constants.OperationsConstants.OPERATION_LOAD_SUCCESS, _constants.OperationsConstants.OPERATION_LOAD_FAIL],
        promise: function promise(client, iBonus) {
            return iBonus.getPipoOperations(begDate, endDate, id_account, page, pageSize).then(function (result) {
                return {
                    data: result,
                    begDate: begDate,
                    endDate: endDate,
                    page: page
                };
            });
        }
    };
}

function morePipoOperations(begDate, endDate) {
    var id_account = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -1;
    var page = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
    var pageSize = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : _constants.OperationsNumericConstants.OPERATIONS_PAGE_LIMIT;

    return {
        types: [_constants.OperationsConstants.MORE_LOAD, _constants.OperationsConstants.MORE_LOAD_SUCCESS, _constants.OperationsConstants.OPERATION_LOAD_FAIL],
        promise: function promise(client, iBonus) {
            return iBonus.getPipoOperations(begDate, endDate, id_account, page, pageSize).then(function (result) {
                return {
                    data: result,
                    begDate: begDate,
                    endDate: endDate,
                    page: page
                };
            });
        }
    };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/actions/operations.js
// module id = 1862
// module chunks = 0